// extracted by mini-css-extract-plugin
export default {"slider":"SliderContainer_slider__kWH3m"};